import tokens from '@kluein/design-tokens';

export const APP_NAV_BAR_HEIGHT = '44px';
export const APP_NAV_BAR_BORDER_WIDTH = tokens.borderWidth.small;
